<template>
  <div class="relative">
    <!-- textarea -->
    <textarea
        v-if="type === 'textarea'"
        :id="id"
        :value="modelValue === null ? '' : modelValue"
        @input="onInput($event)"
        @keydown="$emit('keydown', $event)"
        :class="['material-input peer', inputClass, 'resize-y', label ? 'has-floating-label' : '', error ? '!border-red-500 dark:!border-red-500' : '']"
        :placeholder="placeholder || ' '"
        :required="required"
        :disabled="disabled"
        :name="name"
        :rows="rows"
        :aria-invalid="!!error || undefined"
        :aria-describedby="error ? id + '-error' : undefined"
    ></textarea>

    <!-- input -->
    <input
        v-else
        :id="id"
        :value="modelValue === null ? '' : modelValue"
        @input="onInput($event)"
        @keydown="$emit('keydown', $event)"
        :type="type"
        :class="['material-input peer', inputClass, label ? 'has-floating-label' : '', error ? '!border-red-500 dark:!border-red-500' : '']"
        :placeholder="placeholder || ' '"
        :required="required"
        :disabled="disabled"
        :name="name"
        :min="min"
        :aria-invalid="!!error || undefined"
        :aria-describedby="error ? id + '-error' : undefined"
    />

    <!-- label -->
    <label v-if="label" :for="id" class="material-label">
      {{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>

    <!-- error -->
    <p v-if="error" :id="id + '-error'" class="mt-1 text-sm text-red-600 dark:text-red-400">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    id: {type: String, required: true},
    modelValue: {type: [String, Number], default: null},
    label: {type: String},
    type: {type: String, default: "text"},
    placeholder: {type: String, default: null},
    min: {type: [String, Number], default: "0"},
    required: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    name: {type: String, default: ""},
    inputClass: {type: String, default: ""},
    rows: {type: Number, default: 4},
    number: {type: Boolean, default: false},
    error: {type: String, default: ''},
  },
  methods: {
    onInput(event) {
      let value = event.target.value;
      if (value === "") {
        value = null;
      } else if (this.number && value !== null) {
        value = Number(value);
      }
      this.$emit("update:modelValue", value);
    },
  },
};
</script>

<style scoped>
</style>
